module.exports = __webpack_public_path__ + "static/media/SelectImg.af833978.png";